module.exports = __webpack_public_path__ + "img/img_maede_nukedasou.d800b083.jpg";